export default __webpack_public_path__ + "static/media/Loading_2.e49ca1fd.gif";